import { TextureData } from "../../types/types";
import { Padding } from "../../utils/Padding";
import { RectSize } from "../../utils/RectSize";
import { LoaderFileKeys } from "../constant/AppConstants";
import { OptionsDataManager } from "../managers/OptionsDataManager";
import { AppSettings } from "../managers/AppSettings";
import { BubbleBase } from "./BubbleBase";


/**
 * Same as @see BubbleBase, but with a Text label.
 * @usage:
    const bubble: TextBubble = new TextBubble(this.scene);
    bubble.Init(1, new Padding(9));
    bubble.Build();
    bubble.SetOrigin(0.5, 0.0);
    bubble.SetText("80 - HEARTS");
    bubble.UpdateView();
    bubble.Hide(false);
    bubble.setPosition(300, 300);
    bubble.Show();
    this.add(bubble);
 */
export class TextBubble 
    extends BubbleBase
{
    public txtLabel: Phaser.GameObjects.Text;
    /**
     * Padding from borders of bg (this excludes effects like bg dropshadow, if bg has them)
     */
    protected padding: Padding;
    protected baseFontSize: number;
    protected fontFamily: string;
    

    public override Init(
        bgTextureData: TextureData,
        bgSideWidth: number,
        tipTextureData: TextureData,
        bgEffectsPadding?: Padding,
        baseFontSize?: number,
        fontFamily?: string,
    ): void
    {
        // > contentSize
        // > totalSize
        // > contentSize
        // > origin
        super.Init(bgTextureData, bgSideWidth, tipTextureData, bgEffectsPadding);

        this.baseFontSize = baseFontSize ?? 40;
        this.fontFamily = fontFamily ?? AppSettings.fontFamilies.MontserratMedium;
        this.padding = new Padding(15, 12);
    }

    public Build(): void
    {
        // console.log("Build");

        // > bg
        // > bgTip
        super.Build();

        this.txtLabel = this.scene.make.text({
            style: { 
                color: '#000',
                align: 'center',
                fontSize: this.baseFontSize + "px",
                fontFamily: this.fontFamily,
            }
        });
        this.txtLabel.setOrigin(0.5);
        this.add(this.txtLabel);
    }

    public GetBaseFontSize(): number
    {
        return this.baseFontSize;
    }

    public SetFontSize(size: number): void
    {
        this.txtLabel.setFontSize(size + "px");
    }

    public SetTextWordWrap(wordWrapWidth: number, updateView:boolean = false): void
    {
        this.txtLabel.setWordWrapWidth(wordWrapWidth);

        if (updateView) {
            this.UpdateView();
        }
    }

    public SetText(text: string, updateView: boolean = false): void
    {
        // console.log("SetText");

        this.txtLabel.text = text;

        if (updateView) {
            this.UpdateView();
        }
    }
    
    public override UpdateView(): void
    {
        // calculate content size
        this.contentSize.Set(
            this.padding.left + this.txtLabel.displayWidth + this.padding.right,
            this.padding.top + this.txtLabel.displayHeight + this.padding.bottom,
        );

        // calculate total size (content size plus embedded bg effects)
        this.totalSize.Set(
            this.bgEffectsPadding.left + this.contentSize.width + this.bgEffectsPadding.right,
            this.bgEffectsPadding.top + this.contentSize.height + this.bgEffectsPadding.bottom,
        );

        // set bg size
        this.bg.setSize(this.totalSize.width, this.totalSize.height);

        // snap bg to tip
        this.SnapBgToTip();
        
        // reposition inner content
        // txtLabel
        this.txtLabel.setPosition(this.bg.x, this.bg.y);
    }
}